// extracted by mini-css-extract-plugin
module.exports = {"item-wrap":"Item_item-wrap__107Y8","item-icon":"Item_item-icon__1D11y","item-name":"Item_item-name__1gqF0"};